module.exports = __webpack_public_path__ + "img/asd.3932fc8a.jpg";